<template>
    <b-container>
        <b-row>
            <b-col class="col-12">
                <div class="text-center">
                    <div class="logo"><img src="@/img/logo.png" /></div>
                    <h1 class="page-title bg-secondary text-primary mb-2">{{ $route.meta.title }}</h1>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    computed: {
        ...mapGetters('auth', ['loggedIn'])
    }, 
    methods: {
        ...mapActions('auth', ['logout'])
    }
}
</script>

<style scoped lang="scss">
.page-title {
    font-weighT: 400;
    font-size: 20px;
    text-transform: uppercase;
    padding: 11px 30px 10px;
    margin-bottom: 1px;
}

.logo {
    width: 200px;
    height: 72px;
    margin: 20px 0;

    &--large {
        width: 200px;
        height: 72px;
    }

    img {
        width: 100%;
        max-width:100%;
    }
}
</style>